// extracted by mini-css-extract-plugin
module.exports = {"page":"BlogLayout_page__LyF43","container":"BlogLayout_container__1fiRb","main":"BlogLayout_main__1AC4b"};